import * as React from "react";
import { Icon } from "@blueprintjs/core";

import { Genome } from "../../api";
import { cleanTaxaName } from "../../utils/genomes";

type PartialGenome = Pick<Genome, "taxon_name" | "name" | "external_url">;

export const GenomeHeader = ({ genome }: { genome: PartialGenome }) => {
  return (
    <>
      <i>{cleanTaxaName(genome.taxon_name)}</i>
      {` (${genome.name}) `}
      {genome.external_url && (
        <a target="_blank" rel="noopener noreferrer" href={genome.external_url}>
          <Icon icon="share" />
        </a>
      )}
    </>
  );
};
